import { FC, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { WorkspaceFile } from '@/models/file';
import { useQuery } from '@tanstack/react-query';
import styles from './markdown-preview.module.scss';

interface MarkdownProps {
  doc: WorkspaceFile;
}

const MarkdownPreview: FC<MarkdownProps> = ({ doc }) => {
  const [showCode, setShowCode] = useState<boolean>(false);
  const { data: content } = useQuery<string>({
    queryKey: ['fileContent', doc.id],
    queryFn: async () => {
      const response = await fetch(doc.url);
      if (!response.ok) {
        throw new Error('Failed to fetch file content');
      }
      return response.text();
    },
    staleTime: Infinity,
  });
  return (
    <section className={styles['markdown-preview']}>
      <div className={styles['markdown-preview__controllers']}>
        <button onClick={() => setShowCode(!showCode)}>
          {showCode ? 'Hide Code' : 'Show Code'}
        </button>
      </div>

      {showCode ? (
        <embed
          className={styles['markdown-preview__code']}
          src={doc.url}
          type="application/pdf"
          title={`Preview of ${doc.name}`}
        />
      ) : (
        <div className={styles['markdown-preview__content']}>
          <ReactMarkdown>{content || ''}</ReactMarkdown>
        </div>
      )}
    </section>
  );
};

export default MarkdownPreview;
